import { useCurrentRadioSettings } from '@/stores/radio-settings'
import { defineStore } from 'pinia'
import { computed, MaybeRefOrGetter, toValue } from 'vue'

type Input = {
  source: string
  label: string
  description?: string
}

export function useInput(source: MaybeRefOrGetter<string>) {
  const playoutStore = usePlayoutStore()
  return computed(() => playoutStore.inputs.find((i) => i.source === toValue(source)) ?? null)
}

export const usePlayoutStore = defineStore('playout', () => {
  const radioSettings = useCurrentRadioSettings()

  const inputs = computed<Input[]>(() => {
    const inputs = Object.entries(radioSettings.value?.playout?.lineInChannels ?? {})
    return inputs.map(([id, label]) => ({ source: `line:///${id}`, label }))
  })

  return {
    inputs,
  }
})
